<template>
    <v-container
    class="fill-height"
    fluid
    style="height: 100%;"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        class="text-center"
      >
        <h1>Pago Exitoso</h1>
        <p>El pago fué procesado por Stripe</p>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" class="text-center">
       
          <h1 class="text-h6 text-center"></h1>
          <h2 v-if="chargeData && chargeData.type">Detalle del Pago Stripe: {{ chargeData.type }} </h2>
          
          
            <v-list dense>
              <v-list-item v-if="chargeObject && chargeObject.id">
                <v-list-item-title><strong>ID Stripe: {{ chargeObject.id }}</strong> </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="chargeObject && chargeObject.amount">
                <v-list-item-title><strong>Monto: {{ $currency.format(chargeObject.amount) }}</strong> </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="chargeData && chargeData.created">
                <v-list-item-title><strong>Fecha: {{  $dayjs(chargeData.created).format('ll')  }}</strong> </v-list-item-title>
              </v-list-item>
              
              <v-list-item v-if="chargeObject && chargeObject.status">
                <v-list-item-title><strong>Estatus: {{ chargeObject.status }}</strong> </v-list-item-title>
              </v-list-item>
            </v-list>
             <v-btn block color="primary" large rounded to="/maintenancefees" >Continuar</v-btn> 
         
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import stripeService from '@/services/users/stripe';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);
dayjs.locale('es');
//import maintenancePaymetsService from '@/services/users/stripe';

export default {
   props: {
    paymentId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      localPaymentId: null,
      paymentData: null,
      chargeData: null,
      chargeObject: null,
      webhookEvent:null,
    };
  },
  async mounted(){    
    // Usar variable local, no sobrescribir el prop
    this.localPaymentId = this.$route.query.paymentId || this.paymentId;

    /*const params = new URLSearchParams(window.location.search);
    this.localPaymentId = params.get("paymentId"); // tu ID interno
    this.paymentIntentId = params.get("payment_intent"); // Stripe ID
    this.redirectStatus = params.get("redirect_status"); // succeeded / failed */

    console.log("Cuota local:", this.localPaymentId);
    console.log("Stripe PaymentIntent:", this.paymentIntentId);
    console.log("Status:", this.redirectStatus);
        
    await stripeService.getStripeEvent(this.localPaymentId)
      .then( async res => {       
        this.webhookEvent = res.data;   
        console.log(this.webhookEvent);

        // acceder a la parte `data`
        this.chargeData = JSON.parse(this.webhookEvent.data);   
        this.chargeObject= this.chargeData.data.object;    
        console.log(this.chargeObject.amount);
       
      /*  this.paymentData = await maintenancePaymetsService.fetchById(this.localPaymentId);
        console.log(this.paymentData);

        const paymentIntent= await this.stripe.paymentIntents.retrieve(this.paymentData.stripePaymentIntentId);
          if (paymentIntent.status === 'succeeded') {
            console.log("Pago confirmado ✅");
          } else {
            console.log("Pago pendiente o fallido ❌", paymentIntent.status);
          } */

      }).catch((error) => {
            if (error.response && [400, 404, 409].includes(error.response.status)) {
              this.$swal('Error al cargar Stripe', error.response.data.message, 'warning');
            }
          });
  },
  methods: {
   
  },
};
</script>
